import { color } from '@upstox/upstox-ui';

export const tableCell: CSSFunction<{
  atm: boolean;
}> = ({ theme, cssProps }) => ({
  height: '36px',
  width: '100px',
  fontWeight: 'bold',
  color: color(theme, theme.colors.text[1]),
  textAlign: 'center',
  verticalAlign: 'middle',
  fontSize: '14px',
  lineHeight: '20px',
  fontFamily: 'Messina Sans',
  borderBottom: '1px solid',
  borderColor: color(theme, theme.colors.ui3),
  backgroundColor: color(
    theme,
    cssProps.atm
      ? theme.colors.interactive.ui4.active
      : theme.colors.interactive.row.hover,
  ),
  borderCollapse: 'collapse',
});
